export default __webpack_public_path__ + "static/media/multi-pitch.1eca9678.png";